import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SpreadsheetState } from "./spreadsheet.reducer";


export const getSpreadsheetState = createFeatureSelector<SpreadsheetState>(
  'spreadsheet'
);

export const getWorkbookInfo = createSelector(
  getSpreadsheetState,
  (state: SpreadsheetState) => state.workbookInfo
);

export const getCbcFormsSelector = createSelector(
  getSpreadsheetState,
  (state: SpreadsheetState, countryCode: string) => state.cbcForms[countryCode]
);
